import { createContext, useContext, useState, useEffect } from "react";
import API from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading

  useEffect(() => {
    const token = sessionStorage.getItem("wonstep_token");
    if (!token) {
      setUser(null);
      return;
    }
    API.get("/api/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        sessionStorage.removeItem("wonstep_token");
        setUser(null);
      });
  }, []);

  const login = async (email, password) => {
    const res = await API.post("/api/auth/login", { email, password });
    if (res.data.access_token) {
      sessionStorage.setItem("wonstep_token", res.data.access_token);
    }
    const { access_token, ...userData } = res.data;
    setUser(userData);
    return userData;
  };

  const register = async (email, password, name) => {
    const res = await API.post("/api/auth/register", { email, password, name });
    if (res.data.access_token) {
      sessionStorage.setItem("wonstep_token", res.data.access_token);
    }
    const { access_token, ...userData } = res.data;
    setUser(userData);
    return userData;
  };

  // Clears token synchronously so page reloads start unauthenticated.
  // Fires the server-side cookie clear in the background.
  const logout = () => {
    sessionStorage.removeItem("wonstep_token");
    API.post("/api/auth/logout").catch(() => {});
    // Don't call setUser(null) here — all logout paths use window.location.replace("/")
    // which causes a full page reload. Calling setUser(null) first causes ProtectedRoute
    // to flash the login page before the navigation fires.
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
